import { observable, action, computed } from 'mobx'
import cookie from 'react-cookies'
import _ from 'lodash'
import { USER_MODE, VIP_TIER, BROWSER_KEY } from '../common/Foundation'
import * as mobx from 'mobx';
import Utils from "../common/Utils";
import { BetTypeGroup,   PrefsMap } from './../common/Foundation';
import StorageHelper from '../common/StorageHelper';

export default class AccountStore {
  defaultRequiredFormData = {
    isOpen: false,
    isTriggerClose: false,
    isSessionExpired: false,
    errorMessage: '',
  }
  defaultGDPR = {
    isOpen: false,
    showTermsAndConditions: false,
    showPrivacyPolicy: false,
  }
  defaultLogin2FAData = {
    loginId: '',
    password: '',
    isShowOtpPopup: false,
    loginWithOtpSuccessfully: false,
    otp: '',
    mode: '', // LOGIN | CHANGE_SETTING
    currentUserOtpType: '', 
  }
  defaultUserData = {
    auth: false,
    token: "",
    loginId: "",
    userCode: "",
    freshId: "",
    email: "",
    emailVerification: false,
    fullName: "",
    mode: "",
    type: "",
    betCredit: "",
    outstanding: "",
    currency: "",
    currencyUnit: 0,
    message: "",
    isRefresh: false,
    locale: StorageHelper.getBrowsersStorage(BROWSER_KEY.LOCALE) || 'en_US',
    skin: StorageHelper.getBrowsersStorage(BROWSER_KEY.SKIN) || 'pa',
    openMessage: false,
    'defaultView': '',
    country: "",
    enableMaintenance: false,
    kycStatus: "",
    tier: VIP_TIER[1],
    hasLoginMessage: false,
    betTypeGroup: this.getOptionPreference(),
    maxBetPreferenceSettingBase: false,
    creditWithdrawalEnabled: false,
    cashBonus: undefined,
    totalBalance: "",
    showedAnnouncementLoginWith2FA: true,
    enableLoginWith2FA: false,
    isAccessNewMobileView: false
};

  @observable quickStakeData = {}

  @observable isOpenMessagePopup = false;

  @observable locale = 'en';

  @observable user = this.defaultUserData;

  @observable status = {}

  @observable options = _.isEmpty(localStorage.getItem('perfs')) ? {} : atob(localStorage.getItem('perfs'))

  @observable requiredFormData = this.defaultRequiredFormData;

  @observable isNGC = false;

  @observable gdpr = this.defaultGDPR;

  @observable affiliateCode = cookie.load('afrc') || '';

  @observable isSuspendedByBotDetector = false;

  @observable isMaintenance = false;

  @observable excludeDate = "N/A";

  @observable login2FAData = this.defaultLogin2FAData;
  
  @action setQuickStakeData(value) {
    this.quickStakeData = {...value}
  }

  @action updateEnableQuickStake(value) {
    this.quickStakeData.enableQuickStake = value
  }

  @action setStakeValue(value) {
    this.quickStakeData.stakeValue = [...value]
  }

  @action updateUser(userData) {
    Object.keys(userData).map(key => {
      this.user[key] = userData[key]
    })
  }

  @action updateLoginData(payload) {
    Object.keys(payload).forEach(key => {
      this.login2FAData[key] = payload[key]
    })
  }

  @action resetLoginData() {
    this.login2FAData = this.defaultLogin2FAData
  }

  @action updateOptions(optionsData) {
    this.options = optionsData
  }

  @action changeLocale(locale) {
    this.locale = locale;
  }
  @action updateStatus(status) {
    this.status = status
  }

  @action setRequiredFormData(requiredFormData) {
    let tmp = mobx.toJS(this.requiredFormData)
    
    _.map(requiredFormData, (value, key) => {
      tmp[key] = value;
    });
    this.requiredFormData = tmp;
  }

  @action updateRequiredFormData(key, value) {
    let tmp = mobx.toJS(this.requiredFormData)
    tmp[key] = value;
    this.requiredFormData = tmp;
  }

  @action resetRequiredFormData() {
    this.requiredFormData = this.defaultRequiredFormData;
  }

  @action getOptionPreference (){
    const __prefs = Utils.decodeBase64(StorageHelper.getBrowsersStorage(BROWSER_KEY.__PREFS));
    const __prefsJSON = _.isEmpty(__prefs) ? {} : Utils.convertStringToJSON(__prefs);
    if (!_.isEmpty(__prefsJSON)) {
      return __prefsJSON[PrefsMap.market] === 0 ? BetTypeGroup.HDP_OU : (__prefsJSON[PrefsMap.market] === 1 ? BetTypeGroup.ML_1X2 : BetTypeGroup.TEAM_TOTAL);
    }
    return BetTypeGroup.HDP_OU;
  }

  @action resetWhenCloseRequiredFormData() {
    this.requiredFormData = this.defaultRequiredFormData
    this.requiredFormData.isTriggerClose = true
  }

  @action updateIsOpenMessagePopup(isOpenMessagePopup) {    
    this.isOpenMessagePopup = isOpenMessagePopup;
  }

  @action setIsNGC(boolean) {
    this.isNGC = boolean;
  }
  
  @action setShowTermsAndConditions(flag) {
    this.gdpr.showTermsAndConditions = flag;
  }

  @action setShowPrivacyPolicy(flag) {
    this.gdpr.showPrivacyPolicy = flag;
  }

  @action setOpenGdprNotification(flag) {
    this.gdpr.isOpen = flag;
  }

  @action setExcludeDate(value) {
    this.excludeDate = value
  }

  @action updateAffiliateCode(affCode) {
    this.affiliateCode = affCode;
  }

  @action updateSuspendedByBotDetector(value) {
    this.isSuspendedByBotDetector = value
  }

  @action updateMaintenance(value) {
    this.isMaintenance = value
  }

  @action updateShowedAnnouncementLoginWith2FA(value) {
    this.showedAnnouncementLoginWith2FA = value
  }

  @action updateEnableLoginWith2FA(value) {
    this.enableLoginWith2FA = value
  }

  @computed get isOpenRequiredDialog() { 
    return _.get(this.requiredFormData, 'isOpen', false);
  }

  @computed get isAuth() {
    return this.user.auth;
  }

  @computed get isOpenMessage() {
    return this.isOpenMessagePopup;
  }

  @computed get getCurrency() {
    return this.user.currency;
  }

  @computed get getCurrencyUnit() {
    return this.user.currencyUnit;
  }

  @action resetUser() {
    this.user = this.defaultUserData;
  }

  @computed get hasNewMessage() {
    return _.get(this.user, 'message', 0) > 0;
  }

  @computed get hasNewAnnouncement() {
    return _.get(this.user, 'sumAnnouncement', 0) > 0;
  }
  @computed get enableMaintenance() {
    return _.get(this.user, 'enableMaintenance', false);
  }
  @computed get isCreditUser() {
    return _.isEqual(USER_MODE.CREDIT, this.user.mode);
  }

  @computed get tier() {
    return _.get(this.user, 'tier', VIP_TIER[1]);
  }

  @computed get isVipAccount() {
    const VIP_ID = _.invert(VIP_TIER);
    const tierId = VIP_ID[this.tier];

    return this.isAuth && ![VIP_ID.Regular, VIP_ID.Bronze].includes(tierId);
  }

  @computed get displayedLoginMessage() {
    return  this.isAuth && _.get(this.user, 'hasLoginMessage', false);
  }

  @computed get isShowTermsAndConditions() {
    return _.get(this.gdpr, 'showTermsAndConditions', false);
  }

  @computed get isShowPrivacyPolicy() {
    return _.get(this.gdpr, 'showPrivacyPolicy', false);
  }

  @computed get isOpenGdprNotification() {
    return _.get(this.gdpr, 'isOpen', false);
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/AccountStore.js